export const fileItemTypes = {
  FILE: 'file',
  SPREADSHEET: 'spreadsheet',
  ONLINE_SPREADSHEET: 'onlineSpreadsheet',
  IMAGE: 'image',
  IMPORT: 'import',
  NIL: 'nil',
  PDF: 'pdf',
} as const;

export const fileItemExtensionMap = {
  [fileItemTypes.SPREADSHEET]: ['xlsx', 'xls', 'csv', 'xlsm'],
  [fileItemTypes.IMAGE]: ['bmp', 'jpg', 'jpeg', 'png', 'gif'],
  [fileItemTypes.PDF]: ['pdf'],
} as const;
